import React from 'react';
import { FormattedMessage } from 'react-intl';
import messages from './messages';

const styles = {
  paddingTop: 30,
  borderTop: '1px solid #a9a9a9',
  backgroundColor: '#fff',
};

export default class Layout extends React.Component {
  state = { open: false };
  toggle = () => this.setState({ open: !this.state.open });
  render() {
    return (
      <React.Fragment>
        <span className="attention-title" style={{ width: '20%' }}>
          <FormattedMessage {...messages.attentionTitle} />
        </span>
        <span className="attention-text" style={{ width: '60%' }}>
          <FormattedMessage {...messages.attentionText} />
        </span>
        <span className="attention-btn">
          <button
            onClick={this.toggle}
            role="button"
            style={{ marginRight: 0 }}
            className="persecution-btn">
            <FormattedMessage {...messages.attentionBtn} />
          </button>
        </span>
        <div className="clearfix"></div>
        <div className="loaderBox">
          <div className="text-center loader">
            <div className="preloader-wrapper big active crazy">
              <div className="spinner-layer spinner-blue-only">
                <div className="circle-clipper left">
                  <div className="circle"></div>
                </div>
                <div className="gap-patch">
                  <div className="circle"></div>
                </div>
                <div className="circle-clipper right">
                  <div className="circle"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {this.state.open && <div style={styles}>{this.props.children}</div>}
      </React.Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/apps/harassment-message/layout.js